const menu = {
  key: "states",
  route: "/legacy/states",
  label: "sidebar.states",
  icon: "faMap",
  group: "masterdata",
  order: 40,
  permission: "legacy.states.read"
};

export default menu;